
export default {
    videolist:[{
        'id':1,
        'url':'https://pic.motortime.com/video/2.mp4',
        'pic':'https://pic.motortime.com/avatar/d6/53/d653dd21d0f3780301b4a9e4a8a41d33.jpg',
        'title':'《改装车登台 引无数观众驻足》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'各式斯巴鲁精品改装车依次登台，其中还有网红溜溜哥的专属座驾。',
        'type':'摄影比赛',
        'start':'2019-08-31',
    },{
        'id':2,
        'url':'https://pic.motortime.com/video/6.mp4',
        'pic':'https://pic.motortime.com/avatar/30/3c/303c16093723ebf1e137b2d424c320f4.jpg',
        'title':'《崇礼大聚礼物满满 韩岳老师携BRZ登场》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'水平对置的荣耀崇礼站上，嘉宾在主舞台上狂撒礼品。漂移区由韩岳老师坐镇，驾驶BRZ上演速度与激情！',
        'type':'摄影比赛',
        'start':'2019-08-31',
    },{
        'id':3,
        'url':'https://pic.motortime.com/video/10.mp4',
        'pic':'https://pic.motortime.com/avatar/5d/8b/5d8b4452cc3c0834bfdbea94da281041.jpg',
        'title':'《崇礼滑雪小镇变成中国版秋水会》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'在崇礼的太舞滑雪小镇，各地慕名而来的车友把整个小镇变成了国外大聚的样子。',
        'type':'摄影比赛',
        'start':'2019-08-31',
    },{
        'id':4,
        'url':'https://pic.motortime.com/video/4.mp4',
        'pic':'https://pic.motortime.com/avatar/bc/b1/bcb15c6699d88260145465ca982257d4.jpg',
        'title':'《你可曾见过如此规模的斯巴鲁聚会？》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'水平对置的荣耀是属于斯巴鲁粉丝的大Party，偌大的停车场已经没有空位了！',
        'type':'摄影比赛',
        'start':'2019-06-22',
    },{
        'id':5,
        'url':'https://pic.motortime.com/video/5.mp4',
        'pic':'https://pic.motortime.com/avatar/14/53/1453115c9570dd4d7eafbff4c2b5f170.jpg',
        'title':'《水平对置入场中 斯巴鲁vivio前来助阵》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'甭管你是BRZ还是STI，见到了vivio都是孙子辈的了！',
        'type':'摄影比赛',
        'start':'2019-06-22',
    },{
        'id':6,
        'url':'https://pic.motortime.com/video/8.mp4',
        'pic':'https://pic.motortime.com/avatar/a9/70/a970b9dadf0246e2ebc69aba1cee907e.jpg',
        'title':'《人水平对置的荣耀苏州站 经典车与车迷见面》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'在水平对置的荣耀首站活动中，复刻的斯巴鲁力狮拉力赛车与车迷们见面。活动现场的小车模引得众多小车迷热捧。',
        'type':'摄影比赛',
        'start':'2019-06-22',
    },{
        'id':7,
        'url':'https://pic.motortime.com/video/9.mp4',
        'pic':'https://pic.motortime.com/avatar/19/15/1915437fc01daa515ddea5342e7d951f.jpg',
        'title':'《冠军车与市售车齐亮相 双车飘逸引围观》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'当CRC的冠军赛车与市售车同时亮相，BRZ与原型车通常漂移，大家的目光都被吸引了。',
        'type':'摄影比赛',
        'start':'2019-06-22',
    },{
        'id':8,
        'url':'https://pic.motortime.com/video/11.mp4',
        'pic':'https://pic.motortime.com/avatar/1b/19/1b1959f9853257eb37c8f7817299a4a6.jpg',
        'title':'《各代翼豹风采依旧 车友进场井然有序》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'在车友的精心照料下，各代翼豹都亮丽如新。大家有序进场，让整个聚会显得相当舒畅。',
        'type':'摄影比赛',
        'start':'2019-06-22',
    },{
        'id':9,
        'url':'https://pic.motortime.com/video/3.mp4',
        'pic':'https://pic.motortime.com/avatar/ae/f9/aef99ae3fe2e779c2656d323d28cca07.jpg',
        'title':'《韩岳的驾驶课堂开课啦》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'漂移大师韩岳驾驶BRZ横走漂移，别开生面的驾驶课堂正式开课！',
        'type':'摄影比赛',
        'start':'2019-05-25',
    },{
        'id':10,
        'url':'https://pic.motortime.com/video/12.mp4',
        'pic':'https://pic.motortime.com/avatar/1b/8e/1b8ef33ff3190d4a3352877a16fc29fa.jpg',
        'title':'《向往自由 就是斯巴鲁的品牌理念》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'露营区？漂移区？这些都是斯巴鲁车友们热爱的玩车氛围。',
        'type':'摄影比赛',
        'start':'2019-05-25',
    },{
        'id':11,
        'url':'https://pic.motortime.com/video/7.mp4',
        'pic':'https://pic.motortime.com/avatar/72/0c/720ca27f256dcf15b157e50e3af9df3f.jpg',
        'title':'《全新LS能否复刻香槟杯的经典镜头？》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'初代LS的香槟塔视频早已成为镜电影像，这一次，我们让全新LS500h重现这一镜电镜头，更多香槟杯能不能完成呢？',
        'type':'摄影比赛',
        'start':'2019-01-30',
    },{
        'id':12,
        'url':'https://pic.motortime.com/video/1.mp4',
        'pic':'https://pic.motortime.com/avatar/d9/ea/d9eab85e5f3889f78d9447af07e19b26.jpg',
        'title':'《老森林人与一家人》摄影获奖作品【已结束】',
        'open':'北京御城铭翼网络科技有限公司',
        'content':'一辆老森，与一家四口，一家人最重要的就是整整齐齐。',
        'type':'摄影比赛',
        'start':'2018-06-14',
    }]
}


// WEBPACK FOOTER //
// ./src/libs/video.js